import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import {
  PhasrRecommendationSideMenuDataProviderFactory
} from '../dataProvider/PhasrRecommendationSideMenuDataProviderFactory';
import {
  PhasrRecommendationSideMenuBaseDataProvider
} from '../dataProvider/PhasrRecommendationSideMenuBaseDataProvider';

export class PhasrRecommendationSideMenuRepository extends BaseWebComponentRepository {
  public dataProviderFactory: PhasrRecommendationSideMenuDataProviderFactory;
  public dataProvider: PhasrRecommendationSideMenuBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new PhasrRecommendationSideMenuDataProviderFactory(),
    });
  }

  public async getRecommendation(recommendationId: string): Promise<any> {
    return this.dataProvider.getRecommendation(recommendationId);
  }
}
